module.exports = __webpack_public_path__ + "img/delivery.a47b81c1.webp";